import React from 'react';
import { motion } from 'framer-motion';
import { FadeInUp } from './ui/FadeInUp';
import { SectionEyebrow } from './ui/SectionEyebrow';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'John and Mickie were an incredible asset on our home buying journey! They constantly and consistently provided sound advice regarding many critical events in the purchasing process. My husband and I will be forever thankful to John & Mickie for finding our dream home!',
  name: 'Ryan & Kelsey Matthews'
}, {
  quote: 'I bought this home through the Beshk Group and certainly would do it again! They are professional, helpful, knowledgeable, know what they are doing and went the extra mile for me. On moving day Mickie even cleaned the filthy kitchen refrigerator! I was astounded. Best customer service ever.',
  name: 'Sandra Mason'
}, {
  quote: 'John and Mickie are without a doubt the best Realtors I have ever dealt with. Not only are they professional, but they are also hands on and always in communication during the entire buying and selling process. I trust my entire family to use the Beshk Group!',
  name: 'Brian & Missy Low'
}, {
  quote: 'I have known John Beshk for over 30 years. John and his wife Mickie are by far the best and most thorough brokers I have ever worked with. They have many repeat customers because of the highest excellence work they do, their knowledge of real estate, and personal strength of character they constantly display.',
  name: 'Bob Fischer'
}, {
  quote: "Mickie and John are the most professional realtors I've worked with. They are extremely knowledgeable, efficient and personable. They make you feel comfortable and confident with any deal.",
  name: 'Lisa Patnoe'
}];
// Duplicate the array so the marquee loop is seamless
const loop = [...testimonials, ...testimonials];
export function TestimonialsSection() {
  return <section className="py-24 md:py-32 bg-ivory overflow-hidden" data-id="element-273">
      <div className="container mx-auto px-6" data-id="element-274">
        <FadeInUp className="text-center max-w-2xl mx-auto mb-16 md:mb-24" data-id="element-275">
          <SectionEyebrow text="What Clients Say" data-id="element-276" />
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal" data-id="element-277">
            Selling homes. Building friendships.
          </h2>
        </FadeInUp>
      </div>

      <FadeInUp delay={0.2} data-id="element-278">
        <div className="relative group" data-id="element-279">
          {/* Edge fade masks */}
          <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-ivory to-transparent z-10 pointer-events-none" data-id="element-280" />
          <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-ivory to-transparent z-10 pointer-events-none" data-id="element-281" />

          <div className="overflow-hidden" data-id="element-282">
            <motion.div className="flex gap-6 md:gap-8 w-max" animate={{
            x: ['0%', '-50%']
          }} transition={{
            duration: 60,
            ease: 'linear',
            repeat: Infinity
          }} style={{
            willChange: 'transform'
          }} data-id="element-283">
              {loop.map((testimonial, index) => <div key={index} className="w-[85vw] md:w-[420px] lg:w-[460px] shrink-0 bg-white p-8 md:p-12 rounded-xl shadow-sm border border-sand/50 flex flex-col" data-id="element-284">
                  <div className="flex gap-1 text-terracotta mb-8" data-id="element-285">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-286" />)}
                  </div>
                  <p className="text-xl md:text-2xl font-serif text-charcoal italic mb-10 leading-relaxed flex-grow" data-id="element-287">
                    "{testimonial.quote}"
                  </p>
                  <div className="text-xs font-semibold uppercase tracking-widest text-charcoal-text/60" data-id="element-288">
                    {testimonial.name}
                  </div>
                </div>)}
            </motion.div>
          </div>
        </div>
      </FadeInUp>

      <div className="container mx-auto px-6" data-id="element-289">
        <FadeInUp delay={0.4} className="mt-16 text-center" data-id="element-290">
          <div className="inline-flex flex-col items-center" data-id="element-291">
            <div className="flex items-center gap-3 mb-3" data-id="element-292">
              <span className="font-serif text-2xl text-charcoal" data-id="element-293">5.0</span>
              <div className="flex gap-1 text-terracotta" data-id="element-294">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-295" />)}
              </div>
            </div>
            <p className="text-sm text-charcoal-text/70 mb-4" data-id="element-296">
              50+ Reviews on Google
            </p>
            <a href="#" className="text-terracotta font-medium hover:underline underline-offset-4 decoration-terracotta/30 transition-all" data-id="element-297">
              Read All Reviews
            </a>
          </div>
        </FadeInUp>
      </div>
    </section>;
}